import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseCircleLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12,2.25 c -5.3851246,0 -9.75,4.3648754 -9.75,9.75 0,5.384095 4.3648154,9.75 9.75,9.75 5.385195,0 9.75,-4.365905 9.75,-9.75 0,-5.3851246 -4.364905,-9.75 -9.75,-9.75 z m 0,1.5 c 4.556695,0 8.25,3.6932946 8.25,8.25 0,4.555795 -3.693305,8.25 -8.25,8.25 C 7.4433546,20.25 3.75,16.555795 3.75,12 3.75,7.4432946 7.4432946,3.75 12,3.75 Z M 9.6601563,8.9160156 c -0.1919436,0 -0.3848052,0.072305 -0.53125,0.21875 -0.2928998,0.2928897 -0.2928998,0.7676272 0,1.0605474 l 1.8027347,1.802734 -1.8007816,1.800781 c -0.2928997,0.2929 -0.2928997,0.767647 0,1.060547 0.2928897,0.2929 0.7677371,0.2929 1.0605466,0 l 1.800782,-1.800781 1.808593,1.80664 c 0.2928,0.2929 0.767647,0.2929 1.060547,0 0.2929,-0.292899 0.2929,-0.767647 0,-1.060546 l -1.808594,-1.806641 1.802735,-1.800781 c 0.292899,-0.2929001 0.292899,-0.7676475 0,-1.0605472 -0.2929,-0.2928898 -0.767647,-0.2928898 -1.060547,0 L 11.992188,10.9375 10.189453,9.1347656 c -0.14641,-0.1464448 -0.3373532,-0.21875 -0.5292967,-0.21875 z"
	})]
});
export default SvgCloseCircleLine;
